import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export function engineeringLoginState(pathname) {
  return typeof pathname === 'string' && /^\/ai-engineering\/tasks\/[A-Za-z0-9_-]{1,200}$/.test(pathname)
    ? { engineeringTaskPath: pathname } : undefined;
}

export default function EngineeringLoginRoute({ authenticated, children }) {
  const location = useLocation();
  const destination = engineeringLoginState(location.state?.engineeringTaskPath)?.engineeringTaskPath || '/dashboard';
  return authenticated ? <Navigate to={destination} replace /> : children;
}
